import React from 'react';
import { Box } from '@mui/material';
import AppTooltip from '../../../../../../components/AppTooltip';
import { AdminBenchmarkReportWidgets } from '../../../../../../variables/constant';
import StyledCard from '../../../../../../components/StyledCard';
import { AdminBenchmarkGrowthReportChartData } from '../../benchmark-summary-hook';
import NoResults from '../../../../../../components/NoResults';
import EmptyBenchmarkResults from '../../../../../../components/Icons/EmptyBenchmarksResults';
import DonutChartLoader from '../../../../../../components/Loader/DonutChartLoader';
import AdminBenchmarkGrowthReportChart from '../../../../../../components/AdminBenchmarkGrowthReportChart';

interface Props {
  alignTitle?: boolean, // to specify alignment of the component title, default is center.
  enableTooltip?: boolean, // to enable tooltip for this component.
  tooltipTitle?: string, // specifies the text used for Tooltip component.
  hasData: boolean;
  loading: boolean;
  yAxisDomain: number[];
  yAxisTicks: number[];
  growthReportData: AdminBenchmarkGrowthReportChartData[];
}

const GrowthScoreReport = ({
  alignTitle,
  enableTooltip,
  tooltipTitle,
  hasData,
  loading,
  yAxisDomain,
  yAxisTicks,
  growthReportData,
}: Props) => {
  const title: string = 'Benchmark Growth Report';
  return (
    <Box id={AdminBenchmarkReportWidgets.BenchmarkSummary.DistrictBenchmarkGrowthReport.name} sx={{ height: '100%', width: '100%' }}>
      <StyledCard
        title={title}
        columnSetting
        isToolTip={enableTooltip}
        titleAlignment={alignTitle ? 'left' : 'center'}
        toolTipComponent={<AppTooltip toolTipText={tooltipTitle} />}
        fullHeight
        marginBottom='0px'
      >
        {growthReportData && !loading && hasData && (
          <Box sx={{ padding: '0px' }}>
            <AdminBenchmarkGrowthReportChart
              data={growthReportData}
              lineKey1='speakingScore'
              lineKey2='writingScore'
              xAxisKey='benchmarkType'
              chartWidth={630}
              chartHeight={400}
              yAxisDomain={yAxisDomain}
              yAxisTicks={yAxisTicks}
            />
          </Box>
        )}

        {!loading && growthReportData && !hasData && (
          <NoResults
            description={AdminBenchmarkReportWidgets.BenchmarkSummary.DistrictBenchmarkGrowthReport.insufficientData.description}
            svgComponent={<EmptyBenchmarkResults />}
          />
        )}
        {loading && <DonutChartLoader />}
      </StyledCard>
    </Box>

  );
};

export default GrowthScoreReport;